import Cookies from "js-cookie";
class ListingDisplay {
  constructor({
    btnSelector = ".js-list-display-change"
  } = {}) {
    this.btnSelector = btnSelector;
    this.toggleDisplay = this.toggleDisplay.bind(this);
    this.bindEvents();
  }
  toggleDisplay(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    if ($target.hasClass("active")) {
      return;
    }
    const displayType = $target.data("type");
    const $btns = $(this.btnSelector);
    $btns.removeClass("active");
    $btns.filter((i, el) => $(el).data("type") === displayType).addClass("active");
    Cookies.set("displayType", displayType);
    prestashop.emit("updateFacets", window.location.href);
  }
  bindEvents() {
    $(document).on("click", this.btnSelector, this.toggleDisplay);
  }
}
export default ListingDisplay;
